import { Component } from "react";
import queryString from "query-string";
import { eGroupCollection } from "../../store/egroups/types";
import { eGroupRouteProps, Props } from "../propTypes";
import _ from "lodash";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Campus } from "../../store/main/types";
import Error404 from "../404";
import { Helpers } from "./common/helpers";
import { connect } from "react-redux";
import withRouter from "next/dist/client/with-router";
import { mapStateToProps, mapDispatchToProps } from "../../store/mapProps";
import Image from "next/image";
import { shimmer, toBase64 } from "src/js/constants";

interface State {
    loading: boolean;
    collections: eGroupCollection[];
    successTimestamp: number;
    campuses: Campus[];
    selectedCampus: Campus | null;
    selectedCampusSlug: string;
    querystring: queryString.ParsedQuery<string>;
}

class GroupsCollections extends Component<Props & eGroupRouteProps, State> {
    state: State = {
        loading: true,
        collections: [],
        successTimestamp: 0,
        campuses: this.props.main.campuses,
        selectedCampus: null,
        selectedCampusSlug: "",
        querystring: this.props.router.query,
    };

    helpers = new Helpers();

    componentDidMount() {
        if (this.props.main.campuses.length === 0) {
            this.props.actions.main.main_get_all_campuses();
        } else {
            this.setState({
                selectedCampus: this.getCampus(),
            });
        }
    }

    componentDidUpdate() {
        if (
            this.props.eGroups.eGroupHomeData?.templateCollections &&
            (!_.isEqual(
                this.props.eGroups.eGroupHomeData?.templateCollections,
                this.state.collections
            ) ||
                this.props.eGroups.eGroupHomeData?.loadTime !==
                    this.state.successTimestamp)
        ) {
            this.setState({
                loading: this.props.main.campuses.length > 0 ? false : true,
                collections:
                    this.props.eGroups.eGroupHomeData?.templateCollections,
                successTimestamp:
                    this.props.eGroups.eGroupHomeData?.loadTime || 0,
            });
        }

        if (!_.isEqual(this.props.main.campuses, this.state.campuses)) {
            this.setState({
                loading:
                    this.props.eGroups.eGroupHomeData?.templateCollections
                        .length > 0
                        ? false
                        : true,
                campuses: this.props.main.campuses,
                selectedCampus: this.getCampus(),
            });
        }

        if (
            !_.isEqual(
                this.props.router.query.campus
                    ? this.props.router.query.campus[
                          this.props.router.query.campus.length - 1
                      ]
                    : "",
                this.state.selectedCampusSlug
            )
        ) {
            this.setState({
                selectedCampus: this.getCampus(),
                selectedCampusSlug:
                    this.props.router.query.campus &&
                    this.props.router.query.campus[
                        this.props.router.query.campus.length - 1
                    ],
            });
        }
    }

    getCampus = (): Campus | null => {
        let campusToReturn: Campus | null = null;

        if (this.props.router.query.campus) {
            this.props.main.campuses.forEach((campus) => {
                if (
                    campus.slugName.toLowerCase() ===
                    this.props.router.query.campus[
                        this.props.router.query.campus.length - 1
                    ]
                ) {
                    campusToReturn = campus;
                }
            });
        }

        return campusToReturn;
    };

    renderLoading = () => {
        return (
            <>
                <div className="collection-item d-block ec-border-radius full-width">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md photo-wrapper square rel-pos ec-border-radius full-width flex-two-column" />
                </div>
                <div className="collection-item d-block ec-border-radius full-width">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md photo-wrapper square rel-pos ec-border-radius full-width flex-two-column" />
                </div>
                <div className="collection-item d-block ec-border-radius full-width">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md photo-wrapper square rel-pos ec-border-radius full-width flex-two-column" />
                </div>
                <div className="collection-item d-block ec-border-radius full-width">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md photo-wrapper square rel-pos ec-border-radius full-width flex-two-column" />
                </div>
                <div className="collection-item d-block ec-border-radius full-width">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md photo-wrapper square rel-pos ec-border-radius full-width flex-two-column" />
                </div>
                <div className="collection-item d-block ec-border-radius full-width">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md photo-wrapper square rel-pos ec-border-radius full-width flex-two-column" />
                </div>
            </>
        );
    };

    renderRealContent = () => {
        let collections = this.state.collections.filter(
            (item) => item.isActive
        );
        if (this.state.querystring && this.state.querystring.group) {
            collections = collections.filter(
                (item) => item.group === this.state.querystring.group
            );

            if (collections.length < 1) {
                collections = this.state.collections;
            }
        }

        return (
            <>
                {collections.map((collection, key) => {
                    const { image, title, layout } = collection;
                    let { link } = collection;

                    const wrapperClass =
                        "collection-item d-block ec-border-radius full-width";

                    if (link && link.includes(":campus")) {
                        if (!_.isEmpty(this.state.selectedCampus)) {
                            link = link.replace(
                                ":campus",
                                this.state.selectedCampus?.slugName || ""
                            );
                        } else {
                            link = link.replace(":campus", "");
                        }
                    }

                    if (link && link.includes(":today")) {
                        link = link.replace(
                            ":today",
                            new Date()
                                .toLocaleString("en-us", {
                                    weekday: "long",
                                })
                                .toLowerCase()
                        );
                    }

                    if (this.state.querystring.campusSelector) {
                        link += "&campusSelector=1";
                    }

                    const content = (
                        <div className="hover-grow">
                            {image ? (
                                <div className="photo-wrapper square rel-pos background-white ec-border-radius full-width">
                                    <Image
                                        key={key}
                                        sizes="240px"
                                        layout="fill"
                                        objectFit={"cover"}
                                        objectPosition={"top"}
                                        src={image}
                                        alt={`Collection ${collection.title}`}
                                        placeholder="blur"
                                        blurDataURL={`data:image/svg+xml;base64,${toBase64(
                                            shimmer(72, 72)
                                        )}`}
                                    />
                                </div>
                            ) : null}

                            {layout.showTitle ? (
                                <h4 className="m-y-spacer-none text-center m-t-spacer-sm ec-secondary-font text-dark">
                                    {title}
                                </h4>
                            ) : null}
                        </div>
                    );

                    const id = `cc-egroups${
                        this.props.eGroups.eGroupHomeData?.name
                            ? `-${this.props.eGroups.eGroupHomeData.name.toLowerCase()}`
                            : ""
                    }${
                        this.state.selectedCampus?.slugName
                            ? `-${this.state.selectedCampus?.slugName}`
                            : ""
                    }-collections-${collection.title
                        .replace(/ /g, "-")
                        .toLowerCase()}`;

                    if (link) {
                        const linkClass = `${wrapperClass} image`;

                        if (layout.externalLink) {
                            return (
                                <CSSTransition
                                    key={key}
                                    classNames="show-animation"
                                    timeout={300}
                                    in={true}
                                >
                                    <a
                                        href={link}
                                        className={linkClass}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        key={key}
                                        id={id}
                                    >
                                        {content}
                                    </a>
                                </CSSTransition>
                            );
                        }

                        return (
                            <CSSTransition
                                key={key}
                                classNames="show-animation"
                                timeout={300}
                                in={true}
                            >
                                <a
                                    href={link}
                                    className={linkClass}
                                    style={{
                                        transitionDelay: `${key * 75}ms`,
                                    }}
                                    id={id}
                                >
                                    {content}
                                </a>
                            </CSSTransition>
                        );
                    }

                    return (
                        <CSSTransition
                            key={key}
                            classNames="show-animation"
                            timeout={300}
                            in={true}
                        >
                            <div
                                className={wrapperClass}
                                style={{ transitionDelay: `${key * 75}ms` }}
                            >
                                {content}
                            </div>
                        </CSSTransition>
                    );
                })}
            </>
        );
    };

    render() {
        if (!this.state.loading && this.state.collections.length < 1) {
            return <Error404 />;
        }

        return (
            <div className="container collections-container p-y-spacer-2xl max-w-800">
                <h1 className="m-y-spacer-none font-size-40 ln-height-reset">
                    Collections
                    {this.state.querystring && this.state.querystring.title
                        ? `: ${this.state.querystring.title}`
                        : ""}
                </h1>
                <h2 className="m-y-spacer-none font-size-18 prim-font ec-text-grey regular">
                    Curated{" "}
                    {this.state.selectedCampus
                        ? this.state.selectedCampus.name
                        : ""}{" "}
                    eGroups to help you find the one for you.
                </h2>
                <TransitionGroup
                    component="div"
                    className="collections-wrapper grid flex-align-center flex-justify-start m-t-spacer-xl"
                >
                    {this.state.loading
                        ? this.renderLoading()
                        : this.renderRealContent()}
                </TransitionGroup>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GroupsCollections));
